import React from "react";
import { useDispatch } from "react-redux";
import { OrderByName } from "../../actions";
import "./OrderByName.css"


export default function OrderName({setcurrentPage, setOrden}){

    const dispatch = useDispatch();


   //ordenamos de la A-Z y de Z-A
   function handleOrderName(event){
    event.preventDefault();
    dispatch(OrderByName(event.target.value));
    setcurrentPage(1)
    setOrden(`orden ${event.target.value}`)
    }   


    return(
        <div className="container3">
            <select className="selectmain2" onChange={event =>{handleOrderName(event)}}>
                <option value="all">Ordenar</option>
                <option value="asc">ascendente A-Z</option>
                <option value="desc">descendente Z-A</option>
            </select>
            <i></i>
        </div>
    )
}